export default "__VITE_ASSET__a6583569__"